import { defineStore } from 'pinia'
import { api } from '@/plugins/api'
import { authStore } from './auth'
import { locationStore } from './location'

export const inspectionStore = defineStore('inspection', {
  id: 'inspection',
  state: () => ({
    listParams: {
      page: 1,
      pageSize: 10,
      filterOptions: null,
      filterBy: null,
      sortBy: 'desc',
      orderBy: 'CreatedOn',
      searchTerm: ''
    },
    loading: {
      inspections: false,
      inspection: false,
      repairLines: false
    },
    inspections: [],
    inspection: null,
    repairLines: [],
    lineEntries: [],
    originalLineEntries: [],
    copiedCells: [],
    selectedCells: [],
    sentItems: [],
    alldataLink: 'https://my.alldata.com',
    rtsICarLink: 'https://rts.i-car.com/search-by-vehicle.html',
    oem1StopLink: 'https://www.oem1stop.com',
    fitRevLink: 'https://fit-portal.com',
    oemLinks: [
      { "id": 1, "make": "Acura", "href": "/content/acura" },
      { "id": 2, "make": "Audi", "href": "/content/audi" },
      { "id": 3, "make": "BMW", "href": "https://www.bmwtechinfo.com/" },
      { "id": 4, "make": "Buick", "href": "/content/buick" },
      { "id": 5, "make": "Cadillac", "href": "/content/cadillac" },
      { "id": 6, "make": "Chevrolet", "href": "/content/chevrolet" },
      { "id": 7, "make": "Chrysler", "href": "/content/chrysler" },
      { "id": 8, "make": "Dodge", "href": "/content/dodge" },
      { "id": 9, "make": "Fiat", "href": "/content/fiat" },
      { "id": 10, "make": "Ford", "href": "/content/ford" },
      { "id": 11, "make": "Genesis", "href": "/content/genesis" },
      { "id": 12, "make": "GMC", "href": "/content/gmc" },
      { "id": 13, "make": "Honda", "href": "/content/honda" },
      { "id": 14, "make": "Hummer", "href": "/content/hummer" },
      { "id": 15, "make": "Hyundai", "href": "/content/hyundai" },
      { "id": 16, "make": "Infiniti", "href": "/content/infiniti" },
      { "id": 17, "make": "Isuzu", "href": "http://isuzusource.com/v2/index.php" },
      { "id": 18, "make": "Jaguar", "href": "/content/jaguar" },
      { "id": 19, "make": "Jeep", "href": "/content/jeep" },
      { "id": 20, "make": "Kia", "href": "/content/kia" },
      { "id": 21, "make": "Land Rover", "href": "/content/land-rover" },
      { "id": 22, "make": "Lexus", "href": "/content/lexus" },
      { "id": 23, "make": "Lincoln", "href": "/content/lincoln" },
      { "id": 24, "make": "Mazda", "href": "/content/mazda" },
      { "id": 25, "make": "Mercedes-Benz", "href": "/content/mercedes-benz" },
      { "id": 26, "make": "Mercury", "href": "/content/mercury" },
      { "id": 27, "make": "Mini", "href": "https://www.minitechinfo.com/" },
      { "id": 28, "make": "Mitsubishi", "href": "https://mitsubishitechinfo.com" },
      { "id": 29, "make": "Nissan", "href": "/content/nissan" },
      { "id": 30, "make": "Oldsmobile", "href": "/content/oldsmobile" },
      { "id": 31, "make": "Pontiac", "href": "/content/pontiac" },
      { "id": 32, "make": "Porsche", "href": "https://www.porsche.com/usa/accessoriesandservices/porscheservice/additionalinformation/" },
      { "id": 33, "make": "Ram", "href": "/content/ram" },
      { "id": 34, "make": "Rivian", "href": "/content/rivian" },
      { "id": 35, "make": "Saturn", "href": "/content/saturn" },
      { "id": 36, "make": "Scion", "href": "/content/scion" },
      { "id": 37, "make": "Subaru", "href": "/content/subaru" },
      { "id": 38, "make": "Suzuki", "href": "https://suzukipitstopplus.com/" },
      { "id": 39, "make": "Tesla", "href": "/content/tesla" },
      { "id": 40, "make": "Toyota", "href": "/content/toyota" },
      { "id": 41, "make": "Volkswagen", "href": "/content/volkswagen" },
      { "id": 42, "make": "Volvo", "href": "/content/volvo" }
    ],
    consumables: [],
    fitRevReports: [],
    fitCommit: null
  }),
  actions: {
    isInsurer() {
      const store = locationStore()
      let preferences = store.preferences
      let _is = false
      if (preferences.length > 0) {
        let item = preferences.filter((x) => x.name === 'isInsurer')
        if (item.length > 0) {
          _is = item[0].value === '1' || item[0].value.toUpperCase() === 'TRUE'
        }
      }
      return _is
    },
    setListParam(data) {
      this.listParams[data.name] = data.value
    },
    setLoading(data) {
      this.loading[data.name] = data.value
    },
    uncheckLineEntries() {
      this.lineEntries.forEach((entry) => {
        entry.isChecked = false
      })
    },
    resetItems() {
      this.sentItems = []
    },
    setItem(data) {
      this.sentItems.push(data)
    },
    setInspection(data) {
      switch (data.name) {
        case 'insurance': {
          this.inspection.insurance = parseInt(data.value)
          // returned so callers can await the save before re-fetching pricing
          return this.updateInspection({
            adasInspection: this.inspection.adasInspection,
            insurance: parseInt(data.value)
          })
        }
        default:
      }
    },
    checkAllLineEntries(value) {
      this.lineEntries.forEach((entry) => {
        entry.isChecked = value
      })
    },
    async getInspections(options) {
      this.inspections = []
      this.consumables = []
      this.fitRevReports = []
      this.fitCommit = null
      this.loading.inspections = true
      this.inspections = await api.get('dashboard/clientLocationInspections', options)
      this.loading.inspections = false
      console.log('Got Inspections', this.inspections)
      return this.inspections
    },
    async getInspection(id) {
      let cnt = 1
      this.consumables = []
      this.fitRevReports = []
      this.lineEntries = []
      this.originalLineEntries = []
      this.ivsWizardItems = []
      this.inspection = null
      this.loading.inspection = true
      this.inspection = await api.get(`blueprint/inspection?adasInspection=${id}`)
      this.loading.inspection = false
      let isSent = false
      let isCaptured = false
      let isComplete = false
      let found = null
      if (this.inspection) {
        // ADAS Map Entries
        if (this.inspection.results) {
          this.inspection.results.forEach(element => {
            isSent = false
            isCaptured = false
            isComplete = false
            if (this.inspection.sentItems) {
              found = this.inspection.sentItems.find((item) => 
                item.diagnostic?.trim().toUpperCase() === element.diagnostic?.trim().toUpperCase()
                && item.item?.trim().toUpperCase() === element.item?.trim().toUpperCase()
                && item.description?.trim().toUpperCase() === element.service?.trim().toUpperCase()
                && item.location?.trim().toUpperCase() === element.location?.trim().toUpperCase()
                && item.system?.trim().toUpperCase() === element.system?.trim().toUpperCase()
              )
              if (found) {
                isSent = true
                isCaptured = found.isCaptured
                isComplete = found.isComplete
                
              }
            }
            this.lineEntries.push({
              id: element.adasInspectionResult,
              line: cnt,
              isChecked: false,
              category: 'ADAS',
              source: 'ADAS Map',
              description: element.service,
              insurerServiceName: element.insurerServiceName,
              // #619: a compound "&" line is split into per-component parts; each
              // component carries its own insurer parts-code name. Carry the array
              // through so LineEntries can preview/copy the component names.
              components: element.components,
              triggerNotice: element.triggerNotice,
              isFlagged: element.isFlagged,
              quantity: 1,
              price: element.price,
              discount: element.discount,
              system: element.system,
              location: element.location,
              item: element.item,
              diagnostic: element.diagnostic,
              systemType: element.systemType,
              isSent: isSent,
              isCaptured: isCaptured,
              isComplete: isComplete
            })
            cnt++
          }) 
        }
        // IVS Wizard Entries
        if (this.inspection.ivsWizardResponse && !this.isInsurer()) {
          isSent = false
          isCaptured = false
          isComplete = false
          let proceed = true
          if (this.inspection.ivsWizardResponse.ErrorMessage && this.inspection.ivsWizardResponse.ErrorMessage !== '') {
            proceed = false
          }
          if (proceed) {
            if (this.inspection.sentItems) {
              let tempDesc =
                this.inspection.ivsWizardResponse.Pre && this.inspection.ivsWizardResponse.Pre.Description
                  ? this.inspection.ivsWizardResponse.Pre.Description.toUpperCase()
                  : 'PRE-SCAN OE SCAN'

              found = this.inspection.sentItems.find((item) => item.description?.trim().toUpperCase() === tempDesc)
              if (found) {      
                isSent = true
                isCaptured = found.isCaptured
                isComplete = found.isComplete
              }
            }
            
            let description = null
            let reasons = null
            let price = null
            let pre = null

            if (this.inspection.ivsWizardResponse.Pre !== null) {
              pre = this.inspection.ivsWizardResponse.Pre

              if(pre) {
                description = (pre.Description) ? pre.Description : 'Pre-Scan OE Scan'
                reasons = (pre.Reasons) ? pre.Reasons.join(',') : ''
                price = (pre.Retail) ? pre.Retail : 0
              }
            }
            console.log('IVS Wizard Pre', {
              pre: pre,
              description: pre?.Description
            })
            this.lineEntries.push({
              id: 1,
              line: cnt,
              isChecked: false,
              category: 'Scans',
              source: 'IVS Wizard',
              description: description,
              quantity: 1,
              price: price,
              discount: 0,
              system: null,
              location: reasons,
              item: null,
              diagnostic: null,
              systemType: null,
              isSent: isSent,
              isCaptured: isCaptured,
              isComplete: isComplete
            })
            cnt++
            isSent = false
            isCaptured = false
            isComplete = false
            
            let post = null
            description = null
            reasons = null
            price = null
            pre = null

            if (this.inspection.ivsWizardResponse.Post !== null) {
              post = this.inspection.ivsWizardResponse.Post
              if(post) {
                description = (post.Description) ? post.Description : 'Post-Scan OE Scan'
                reasons = (post.Reasons) ? post.Reasons.join(',') : ''
                price = (post.Retail) ? post.Retail : 0
              }
            }
            if (this.inspection.sentItems) {
              let tempDesc = this.inspection.ivsWizardResponse.Post && this.inspection.ivsWizardResponse.Post.Description
                  ? this.inspection.ivsWizardResponse.Post.Description?.toUpperCase()
                  : 'POST-SCAN OE SCAN'
              found = this.inspection.sentItems.find((item) => item.description?.trim().toUpperCase() === tempDesc)
              if (found) {
                isSent = true
                isCaptured = found.isCaptured
                isComplete = found.isComplete 
              }
            }
           
            console.log('IVS Wizard Post', {
              post: post,
              description: description
            })
            this.lineEntries.push({
              id: 2,
              line: cnt,
              isChecked: false,
              category: 'Scans',
              source: 'IVS Wizard',
              description: description,
              quantity: 1,
              price: price,
              discount: 0,
              system: null,
              location: reasons,
              item: null,
              diagnostic: null,
              systemType: null,
              isSent: isSent,
              isCaptured: isCaptured,
              isComplete: isComplete
            })
            cnt++
            isSent = false
            isCaptured = false
            isComplete = false
            if (this.inspection.sentItems) {
              found = this.inspection.sentItems.find((item) => item.description?.trim().toUpperCase() === 'OE FEE')
              if (found) {      
                isSent = true
                isCaptured = found.isCaptured
                isComplete = found.isComplete   
              }   
            }
            console.log('IVS Wizard OE Fee', {
              found: found,
              isCaptured: isCaptured,
              isComplete: isComplete,
              OEFee: this.inspection.ivsWizardResponse.OEFee
            })
            if (parseFloat(this.inspection.ivsWizardResponse.OEFee) !== 0) {
              this.lineEntries.push({
                id: 3,
                line: cnt,
                isChecked: false,
                category: 'Scans',
                source: 'IVS Wizard',
                description: 'OE Fee',
                quantity: 1,
                price: (this.inspection.ivsWizardResponse.OEFee) ? this.inspection.ivsWizardResponse.OEFee : 0,
                discount: 0,
                system: null,
                location: null,
                item: null,
                diagnostic: null,
                systemType: null,
                isSent: isSent,
                isCaptured: isCaptured,
                isComplete: isComplete
              })
              cnt++
            }
            this.ivsWizardItems = this.lineEntries.filter((entry) => entry.source === 'IVS Wizard')
          }
        }
        // FIT REV Consumables
        if (this.inspection.consumables && !this.isInsurer()) {
          this.consumables = this.inspection.consumables
          this.inspection.consumables.forEach(element => {
            isSent = false
            isCaptured = false
            isComplete = false
            if (this.inspection.sentItems) {
              found = this.inspection.sentItems.find((item) => item.description?.trim().toUpperCase() === element.Description?.trim().toUpperCase())
              if (found) {
                isSent = true
                isCaptured = found.isCaptured
                isComplete = found.isComplete
              }
            }
            this.lineEntries.push({
              id: element.LineNo,
              line: cnt,
              isChecked: false,
              category: 'Consumables',
              source: 'FIT REV',
              description: element.Description,
              quantity: element.Qty,
              price: element.Cost,
              discount: 0,
              system: null,
              location: null,
              item: element.QtyType,
              diagnostic: null,
              systemType: null,
              isSent: isSent,
              isCaptured: isCaptured,
              isComplete: isComplete
            })
            cnt++
          })
        }
        this.fitCommit = {
          VendorId: this.inspection.cccDiagNumber,
          RONumber: this.inspection.ronumber,
          VIN: this.inspection.vehicle?.vin,
          CommitType: 'itemized'
        }
      }
      this.originalLineEntries = JSON.parse(JSON.stringify(this.lineEntries))
      console.log('Got Inspection', {
        inspection: this.inspection,
        lineEntries: this.lineEntries
      })
      return this.inspection
    },
    async getRepairLines(adas) {
      this.repairLines = []
      this.loading.repairLines = true
      this.repairLines = await api.get(`dashboard/repairlines?adas=${adas}`)
      this.loading.repairLines = false
      console.log('Got Repair Lines', this.repairLines)
      return this.repairLines
    },
    filterLineEntries(filter) {
      console.log('Filtering Line Entries by:', filter)
      this.lineEntries = this.originalLineEntries.filter((entry) => {
        return entry.source === filter || filter === 'All'
      })
      console.log('Filtered Line Entries', this.lineEntries)
    },
    async updateStatus(data) {
      return await api.post('adas/updateStatusAdasInspection', data)
    },
    resetCells() {
      this.copiedCells = []
      this.selectedCells = []
    },
    updateInspection(data) {
      console.log('Updating Inspection with data', data)
      return api.post('blueprint/saveInspectionInsurance', {
        adasInspection: data.adasInspection,
        insurance: data.insurance
      })
    },
    cellAction(data) {
      switch (data.name) {
        case 'copy': {
          let found = this.copiedCells.find((cell) => cell.page === data.page && cell.idx === data.idx && cell.data === data.value)
          if (found) {
            this.copiedCells = this.copiedCells.filter((cell) => !(cell.page === data.page && cell.idx === data.idx && cell.data === data.value))
          } else {
            this.copiedCells.push({
              page: data.page,
              data: data.value,
              idx: data.idx
            })
          }
          break
        }
        case 'select': {
          let found = this.selectedCells.find((cell) => cell.page === data.page && cell.idx === data.idx && cell.key === data.key)
          if (found) {
            this.selectedCells = this.selectedCells.filter((cell) => !(cell.page === data.page && cell.idx === data.idx && cell.key === data.key))
          } else {
            this.selectedCells.push({
              page: data.page,
              data: data.value,
              idx: data.idx,
              key: data.key
            })
          }
          break
        }
        case 'total': {
          if (this.selectedCells.length === 0) {
            this.selectedCells.push({
              page: data.page,
              data: data.value.toFixed(2),
              idx: data.idx,
              key: data.key
            })
          } else {
            let found = this.selectedCells.find((cell) => cell.page === data.page)
            if (found) {
              let total = parseFloat(found.data) + parseFloat(data.value)
              found.data = total.toFixed(2)
            }
          }
        }
      }
    },
    async loadFitRevReports(data) {
      this.fitRevReports = []
      let response = await api.post('blueprint/fitReports', data)
      if (response) {
        this.fitRevReports = response.Reports
      }
      console.log('Got Fit Rev Reports', this.fitRevReports)
    },
    async saveSentItems() {
      // save the sent items to the server
      if (this.sentItems.length === 0) {
        return
      }
      return await api.post('blueprint/saveSentItems', this.sentItems)
    }, 
    async sendToFIT() {
      return await api.post('blueprint/commitConsumables', this.fitCommit)
    },
    async sendSelectedToFIT() {
      if (this.fitCommit === null || this.sentItems.length === 0) {
        return
      }
      let data = {
        VendorId: this.fitCommit.VendorId,
        RONumber: this.fitCommit.RONumber,
        VIN: this.fitCommit.VIN,
        CommitType: this.fitCommit.CommitType,
        LineItems: this.sentItems.filter((entry) => entry.isCaptured && entry.source === 'FIT REV')
      }
      console.log('Sending Selected Consumables to FIT REV', data)
      if (data.LineItems.length === 0) {
        return
      }
      return await api.post('blueprint/commitSelectedConsumables', data)
    },
    async sendLineItems(id) {
      if (this.lineEntries.length === 0) {
        return
      }
      let response = await api.get(`blueprint/sendServicesToCCC?adasInspection=${id}`)
      return response
    }
  }
})